/* eslint-disable @typescript-eslint/naming-convention */

export interface IGBMConversationListApi {
  id: string;
  type: string;
  attributes: IGBMConversationItemApi[];
}

export interface IGBMConversationItemApi {
  business_id: string;
  conversationId: string;
  created_at: string;
  id: string;
  meta?: {
    message: string;
    name: string;
    type: 'client' | 'owner';
  };
  platform: string;
  updated_at: string;
}

export interface IGBMMessageItemApi {
  created_at: string;
  fk_conversation: number;
  message: string;
  message_id: string;
  name: string;
  type: string;
}
// ------------------------------------------------

export interface IGBMConversationMessageListApi {
  id: number;
  type: string;
  attributes: IGBMConversationMessageItemApi[];
}

export interface IGBMConversationMessageItemApi {
  id: string; // as number
  conversation_id?: string; // as number
  type: string;
  name: string;
  message: string;
  created_at: string;
}

// ----------------------------------
export interface IGBMConversationMessageReplyApi {
  id: string;
  type: string;
  attributes: IGBMReplyApiProps;
}

export interface IGBMReplyApiProps {
  id: string;
  type: string;
  name: string;
  message: string;
  created_at: CreatedAt;
}

export interface CreatedAt {
  date: string;
  timezone_type: number;
  timezone: string;
}
